import React, { Component } from "react";
import TemplateFormModal from "./TemplateFormModal";
import axios from "axios";
import {
  FiUpload,
  FiX,
  FiMusic,
  FiImage,
  FiVideo,
  FiFile,
} from "react-icons/fi";

export const getMediaIcon = (type) => {
  switch (type) {
    case "image":
      return <FiImage className="text-2xl" />;
    case "video":
      return <FiVideo className="text-2xl" />;
    case "audio":
      return <FiMusic className="text-2xl" />;
    case "document":
      return <FiFile className="text-2xl" />;
    default:
      return <FiFile className="text-2xl" />;
  }
};

class PromotionalTemplates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFormModal: false,
      templateToEdit: null,
      templates: [],
      loading: true,
      error: null,
      loadingSubmit: false
    };
  }

  // Function to fetch promotional templates from backend
  fetchPromotionalTemplates = async () => {
    const { providerId } = this.props;
    
    this.setState({ loading: true, error: null });
    try {
      const data = await this.props.getTemplates(providerId, "Promotional");
      if (data.code !== "0") {
        return this.props.getToastr("Unable to fetch Promotional Templates");
      }
      console.log(data, "parmotional template");
      
      const fetchedTemplates = data.data.map((t) => ({
        _id: t._id,
        templateId: t.templateId,
        name: t.templateName,
        category: t.category || "",
        content: t.content,
        variables: t.variables || [],
        variableMappings:t.variableMappings || {},
        isSetupDone: true,
        lastUpdated: t.updatedAt,
        media: t.media,
      }));
      this.setState({ templates: fetchedTemplates });
    } catch (err) {
      console.error("Error fetching promotional templates:", err);
      this.setState({ error: "Failed to load promotional templates. Please try again.", templates: [] });
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    const { providerId } = this.props;
    if (providerId) {
      this.fetchPromotionalTemplates();
    }
  }

  componentDidUpdate(prevProps) {
    const { providerId } = this.props;
    if (prevProps.providerId !== providerId && providerId) {
      this.fetchPromotionalTemplates();
    }
  }

  handleModalSubmit = async (formData) => {
    const { registrationId, providerId } = this.props;
    
    console.log(formData, "formdata");
    try {
      this.setState({ loadingSubmit: true });
      const payload = {
        registrationId: registrationId,
        templateId: formData.templateId,
        templateName: formData.name,
        providerId: providerId,
        contentType: "Promotional",
        content: formData.content,
        variables: formData.variables,
        variableMappings:formData.variableMappings,
        media: formData.media,
        id: formData._id,
      };

      let response;
      if (!formData._id) {
        response = await this.props.createTemplate(payload);
      } else {
        response = await this.props.updateTemplate(payload);
      }

      await this.fetchPromotionalTemplates();

      console.log(
        `Promotional template "${formData.name}" ${
          formData._id ? "updated" : "created"
        } successfully!`
      );
      this.setState({ showFormModal: false });
    } catch (err) {
      console.error("Error upserting promotional template:", err);
      alert(err.message || "Failed to save template. Please try again.");
    } finally {
      this.setState({ loadingSubmit: false });
    }
  };

  handleCreatePromotional = () => {
    this.setState({
      templateToEdit: {
        id: "",
        name: "",
        category: "",
        content: "",
        variables: [],
        variableMappings:{},
        isSetupDone: false,
        _id: null,
      },
      showFormModal: true
    });
  };

  handleEditPromotional = (template) => {
    console.log("template",template);
    this.setState({
      templateToEdit: template,
      showFormModal: true
    });
  };

  handleDeletePromotional = async (template) => {
    const templateMongoId = template._id;
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this promotional template?"
    );

    if (isConfirmed) {
      try {
        this.setState({ loadingSubmit: true });
        const data = await this.props.deleteTemplate(templateMongoId);
        if (data.code === "1") {
          return this.props.getToastr("unable to delete, server issue");
        }
        await this.fetchPromotionalTemplates();
        console.log("Promotional template deleted successfully.");
      } catch (err) {
        console.error("Error deleting promotional template:", err);
        alert("Failed to delete template. Please try again.");
      } finally {
        this.setState({ loadingSubmit: false });
      }
    }
  };

  formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleString();
  };

  renderMediaPreview = (media) => {
    if (!media) return null;
    if (!media.type) return null;

    if (media.type === "image" && media.url) {
      return <img src={media.url} alt={media.filename} style={styles.mediaImage} />;
    }

    if (media.type === "video" && media.url) {
      return <video controls style={styles.mediaVideo} src={media.url} />;
    }

    if (media.type === "audio" && media.url) {
      return (
        <audio controls style={styles.mediaAudio}>
          <source src={media.url} />
        </audio>
      );
    }

    if (media.type === "document") {
      return (
        <div style={styles.documentContainer}>
          <div style={styles.documentIcon}>
            {getMediaIcon(media.type)}
          </div>
          <div style={styles.documentContent}>
            <p style={styles.documentTitle}>{media.filename || "Media attachment"}</p>
            <p style={styles.documentType}>{media.type.toUpperCase()}</p>
            {media.url && (
              <a
                href={media.url}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.documentLink}
              >
                View
              </a>
            )}
          </div>
        </div>
      );
    }

    return null;
  };

  render() {
    const { showFormModal, templateToEdit, templates, loading, error, loadingSubmit } = this.state;
    const { uploadFileToServer, registration, getEventVariables } = this.props;

    if (loading) {
      return (
        <div style={styles.container}>
          <div style={styles.loadingContainer}>Loading templates...</div>
        </div>
      );
    }

    if (error) {
      return (
        <div style={styles.container}>
          <div style={styles.errorContainer}>Error: {error}</div>
        </div>
      );
    }

    return (
      <>
        <div style={styles.container}>
          <div style={styles.header}>
            <h2 style={styles.title}>Your Promotional Templates</h2>
            <button
              onClick={this.handleCreatePromotional}
              style={styles.createButton}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                style={{ width: "20px", height: "20px" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
              <span>Create New Template</span>
            </button>
          </div>

          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Template Name</th>
                  <th style={styles.th}>Content Preview</th>
                  <th style={styles.th}>Last Updated</th>
                  <th style={styles.th}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {templates.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={styles.emptyRow}>
                      No promotional templates created yet. Click 'Create New Template' to get started!
                    </td>
                  </tr>
                ) : (
                  templates.map((template) => (
                    <tr key={template._id || template.templateId}>
                      <td style={styles.td}>{template.name}</td>
                      <td style={styles.td}>
                        <div>
                          {this.renderMediaPreview(template.media)}
                          <span style={styles.contentText}>{template.content}</span>
                        </div>
                      </td>
                      <td style={styles.td}>{this.formatDate(template.lastUpdated)}</td>
                      <td style={styles.td}>
                        <div style={styles.actionButtons}>
                          <button
                            onClick={() => this.handleEditPromotional(template)}
                            style={styles.editButton}
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => this.handleDeletePromotional(template)}
                            style={styles.deleteButton}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <TemplateFormModal
             {...this.props}
          isOpen={showFormModal}
          onClose={() => this.setState({ showFormModal: false })}
          onSubmit={this.handleModalSubmit}
          initialData={templateToEdit}
          templateType="promotional"
          loading={loadingSubmit}
          uploadFileToServer={uploadFileToServer}
          registration={registration}
          getEventVariables={getEventVariables}
        />
      </>
    );
  }
}

const styles = {
  container: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(4px)",
    borderRadius: "24px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    borderBottom: "1px solid #e2e8f0",
    paddingBottom: "16px"
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#475569"
  },
  createButton: {
    backgroundColor: "#16a34a",
    color: "#ffffff",
    fontWeight: "600",
    padding: "10px 24px",
    borderRadius: "12px",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s"
  },
  tableContainer: {
    overflowX: "auto",
    borderRadius: "12px"
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#ffffff"
  },
  th: {
    textAlign: "left",
    padding: "12px 16px",
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
    fontWeight: "600",
    color: "#475569"
  },
  td: {
    padding: "12px 16px",
    borderBottom: "1px solid #e2e8f0",
    verticalAlign: "top"
  },
  actionButtons: {
    display: "flex",
    gap: "8px"
  },
  editButton: {
    padding: "4px 12px",
    backgroundColor: "#3b82f6",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "12px"
  },
  deleteButton: {
    padding: "4px 12px",
    backgroundColor: "#ef4444",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "12px"
  },
  mediaImage: {
    borderRadius: "8px",
    maxWidth: "240px",
    marginBottom: "8px"
  },
  mediaVideo: {
    borderRadius: "8px",
    maxWidth: "240px",
    marginBottom: "8px"
  },
  mediaAudio: {
    width: "280px",
    marginBottom: "8px"
  },
  documentContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "8px",
    width: "240px",
    marginBottom: "8px"
  },
  documentIcon: {
    backgroundColor: "#eff6ff",
    color: "#2563eb",
    padding: "8px",
    borderRadius: "8px"
  },
  documentContent: {
    flex: 1,
    minWidth: 0
  },
  documentTitle: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  documentType: {
    fontSize: "12px",
    color: "#6b7280"
  },
  documentLink: {
    fontSize: "12px",
    color: "#2563eb",
    textDecoration: "none"
  },
  contentText: {
    display: "block",
    maxWidth: "300px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  },
  loadingContainer: {
    textAlign: "center",
    padding: "40px",
    color: "#64748b"
  },
  errorContainer: {
    textAlign: "center",
    padding: "40px",
    color: "#ef4444"
  },
  emptyRow: {
    textAlign: "center",
    padding: "40px",
    color: "#64748b",
    fontStyle: "italic"
  }
};

export default PromotionalTemplates;